/**
 * This is a feature that is meant to be used when a core lib needs
 * feature flagging based on app context.
 */
export const CrossAppFeature = {
  NoAccessOptions: 'NoAccessOptions',
} as const;

export type CrossAppFeature = (typeof CrossAppFeature)[keyof typeof CrossAppFeature];
